var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinePoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 29,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#2065EC"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14 4.801a9.625 9.625 0 1 0 0 19.25 9.625 9.625 0 0 0 0-19.25M2.625 14.426C2.625 8.144 7.718 3.051 14 3.051s11.375 5.093 11.375 11.375c0 6.283-5.093 11.375-11.375 11.375S2.625 20.71 2.625 14.426",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 20.26V8.593h4.21q1.293 0 2.17.501a3.3 3.3 0 0 1 1.332 1.379q.455.871.455 1.982 0 1.122-.455 1.994a3.3 3.3 0 0 1-1.343 1.373q-.888.495-2.187.495h-2.79V14.58h2.516q.756 0 1.239-.273.482-.274.712-.752.236-.48.236-1.1t-.236-1.094a1.63 1.63 0 0 0-.718-.734q-.482-.268-1.244-.268h-1.864v9.9z"
}))));
export default SvgLinePoint;